interface ICompanyAdminUserRoles {
  admin: string;
  facilityAdmin: string;
  facilityOperator: string;
}

export const CompanyAdminUserRoles: ICompanyAdminUserRoles = {
  admin: "admin",
  facilityAdmin: "facility_admin",
  facilityOperator: "facility_operator",
};

export enum CompanyAdminUserRoleNumber {
  admin = 0,
  facility_admin = 1,
  facility_operator = 2,
}
